<div class="row">
  <label class="col-sm-6" translate>Height</label>
  <div class="col-sm-6">
    <input
      type="number"
      class="form-control form-control-sm"
      [(ngModel)]="component.element.height"
      min="10"
      max="400"
    />
  </div>
</div>
